import { render } from "./sh-skeleton.vue?vue&type=template&id=47263398&scoped=true"
import script from "./sh-skeleton.vue?vue&type=script&lang=js"
export * from "./sh-skeleton.vue?vue&type=script&lang=js"

import "./sh-skeleton.vue?vue&type=style&index=0&id=47263398&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\ahuview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47263398"]])

export default __exports__